import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
// stores
import notify from 'AurionCR/store/modules/notify';
import routes from 'AurionCR/store/modules/routes';
import sources from 'AurionCR/store/modules/sources';
import language from 'AurionCR/store/modules/language';
// sagas
import { authAppSaga } from './auth';
import auth from './auth/auth.ts';
import sourceSaga from 'AurionCR/store/sagas/source';
// custom
import { QM, QMSagas } from 'pages/CreditRatings/QuarterlyMonitoring/components/store';
import { RP, RPSagas } from 'pages/CreditRatings/RatingProcess/components/editor/store';
import { dashboard, dashboardSagas } from 'pages/DashboardReports/components/store';
import { documentPreparationReducer, documentPreparationSaga } from 'pages/RatingPerformance/RatingPerformanceImportAndExportFiles/store';
import { baseApi } from './api';
import { ratingMatrixFrameworkListSlice } from 'services/rating-matrix-framework/slice';
import 'services/rating-matrix-framework/api';
import 'services/methodology/api';
import 'services/rating-matrix-framework-parameter/api';
import 'services/rating-matrix-framework-sub-parameter/api';
import 'services/rating-matrix-framework-tree/api';
import 'services/rating-matrix-framework-option/api';
import 'services/rating-matrix-framework-range/api';
import 'services/rating-matrix-framework-template/api';
import 'services/rating-matrix-framework-consideration/api';
import 'services/rating-matrix-framework-grade-score/api';
import 'services/rating-matrix-framework-instrument-track/api';
import 'services/rating-matrix-framework-instrument-step/api';
import 'services/rating-process-helper/api';

const config = {
  store: {
    auth,
    notify,
    routes,
    sources,
    language,
    QM,
    RP,
    dashboard,
    documentPreparationReducer,
    ratingMatrixFrameworkList: ratingMatrixFrameworkListSlice.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  sagas: [...authAppSaga, ...sourceSaga, ...QMSagas, ...RPSagas, ...dashboardSagas, ...documentPreparationSaga],
};

const sagaMiddleware = createSagaMiddleware();
const rootReducer = combineReducers(config.store);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    }).concat(sagaMiddleware, baseApi.middleware),
  devTools: import.meta.env.DEV,
});

function* rootSaga() {
  yield all(config.sagas);
}

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
